module.exports = __webpack_public_path__ + "static/media/GWZ_Logo_Lavendar_white_RGB.0c94cafe.png";